import { OnvoDashboardDatasources } from "../dashboard_datasources/index.js";
import OnvoBase from "../base.js";
import { Dashboard } from "../types/dashboard.js";

export class OnvoDashboard extends OnvoBase {
  datasources: OnvoDashboardDatasources;
  #id: string;

  constructor(id: string, apiKey: string, options?: { endpoint: string }) {
    super(apiKey, options);
    this.#id = id;
    this.datasources = new OnvoDashboardDatasources(id, apiKey, options);
  }

  /**
   * Updates the widget cache for the dashboard.
   *
   * @return {Promise<{success: boolean, id: string}>} A promise that resolves to an object containing the success and id of the widget.
   */
  updateCache() {
    return this.fetchBase(
      "/api/dashboards/" + this.#id + "/update-cache",
      "POST"
    ) as Promise<Dashboard & { _meta: { status: string, url: string, total?: number, completed?: number } }>;
  }

  /**
   * Exports the dashboard in the specified format.
   *
   * @param {("csv" | "xlsx" | "pdf" | "png" | "jpeg")} format - The format to export the dashboard in.
   * @return {Promise<Blob>} A promise that resolves to a Blob representing the exported dashboard.
   */
  export(format: "csv" | "xlsx" | "pdf" | "png" | "jpeg" | "pptx", theme: "light" | "dark" = "light", tab: number = 0): Promise<Blob> {
    return this.fetchBlob(
      `/api/dashboards/${this.#id}/export?theme=${theme}&format=${format}&tab=${tab}`
    );
  }

  /**
   * Summarizes the dashboard using the provided prompt.
   *
   * @param {string} prompt - The prompt to use for summarizing the dashboard.
   * @return {Promise<{title: string, description: string}>} A promise that resolves to an object containing the title and description of the summarized dashboard.
   */
  summarize(prompt: string): Promise<{ title: string; description: string }> {
    return this.fetchBase(`/api/dashboards/${this.#id}/summarize`, "POST", {
      prompt,
    });
  }
}
